import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../../util/utils';

import {accessLogIcon} from '../../../../../util/svgIcons';

import Modal from '../../../../CoreWrappers/Modal';
import AccessLogContent from './AccessLogContent';
import ToolbarButton from '../ToolbarButton';

const AccessLog = () => {
	const [open, setOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const renderTrigger = () => {
		const props = {
			label: labels.toolbarAccessLog,
			svg: accessLogIcon,
			onClick: () => setOpen(true)
		};

		return <ToolbarButton {...props} />;
	};

	const renderModal = () => {
		const props = {
			show: open,
			modalsize: 'medium',
			headerText: labels.accessLog,
			labels: {
				modalConfirmBtnLabel: labels.closeLabel,
				modalCancelBtnLabel: '',
				modalCloseBtnTitletip: labels.closeLabel
			},
			onClose: () => setOpen(false),
			onOkClick: () => setOpen(false),
			isLoading,
			hideCancelButton: true
		};

		return (
			<Modal {...props}>
				<AccessLogContent isLoading={isLoading} setIsLoading={setIsLoading} />
			</Modal>
		);
	};

	return (
		<>
			{renderTrigger()}
			{open && renderModal()}
		</>
	);
};

AccessLog.propTypes = {};

AccessLog.defaultProps = {};

export default AccessLog;
